export default {
  type: "object",
  required: ["scriptText"],
  properties: {
    scriptText: {
      type: "string",
      title: "Script Text",
      maxLength: 600,
    },
    isActive: {
      type: "boolean",
      title: "Is Active",
    },
  },
  urn:
    "urn:jsonschema:eu:firstcare:api:v1:dto:serviceconfig:approvals:standardscript:StandardScriptRevisionDTO",
};
